import type { ModalInfo } from '@entities/info-modal';

export const exitModalLabels: ModalInfo = {
	modalText: 'Вы уверены, что хотите завершить текущий звонок?',
	applyButton: {
		text: 'Завершить',
		type: 'destructive',
	},
	cancelButton: {
		text: 'Назад',
		type: 'secondary',
	},
};

export const parkingModalLabels: ModalInfo = {
	modalText:
		'После парковки текущий звонок завершится. Вы или другие пользователи сможете продолжить его из списка припаркованных звонков.',
	applyButton: {
		text: 'Припарковать',
		type: 'primary',
	},
	cancelButton: {
		text: 'Назад',
		type: 'secondary',
	},
};
